"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var EventHandlerService_1 = require("../Services/EventHandlerService");
require("../Styles/ErrorMessage.scss");
var EventModal = /** @class */ (function (_super) {
    __extends(EventModal, _super);
    function EventModal(props) {
        var _this = _super.call(this, props) || this;
        _this.close = function (actionCallback) {
            actionCallback && actionCallback();
            EventHandlerService_1.EventHandlerProvider.GetInstance().HandleEvent();
        };
        _this.closeBtn = function (currentEvent) {
            var _a;
            return ((_a = currentEvent) === null || _a === void 0 ? void 0 : _a.closeOption) ? React.createElement("button", { className: "close", onClick: function () { _this.close(); } }, "\u00D7") : React.createElement("div", null);
        };
        return _this;
    }
    EventModal.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var currentEvent = EventHandlerService_1.EventHandlerProvider.GetInstance().GetEvent();
        return (React.createElement(reactstrap_1.Modal, { isOpen: EventHandlerService_1.EventHandlerProvider.GetInstance().HasEvent(), toggle: function () { return _this.close; }, backdrop: ((_a = currentEvent) === null || _a === void 0 ? void 0 : _a.backdrop) || undefined, keyboard: ((_b = currentEvent) === null || _b === void 0 ? void 0 : _b.allowKeyboard) || undefined },
            React.createElement(reactstrap_1.ModalHeader, { className: "text-" + ((_c = currentEvent) === null || _c === void 0 ? void 0 : _c.color), toggle: function () { _this.close(); }, close: this.closeBtn(currentEvent) }, (_d = currentEvent) === null || _d === void 0 ? void 0 : _d.title),
            React.createElement(reactstrap_1.ModalBody, null, (_e = currentEvent) === null || _e === void 0 ? void 0 : _e.content),
            React.createElement(reactstrap_1.ModalFooter, null, (_f = currentEvent) === null || _f === void 0 ? void 0 : _f.actions.map(function (action) {
                return React.createElement(reactstrap_1.Button, { color: action.color, key: action.text, onClick: function () { return action.callback(currentEvent, function (actionCallback) { return _this.close(actionCallback); }); }, disabled: action.isDisabled }, action.text);
            }))));
    };
    return EventModal;
}(React.Component));
exports.EventModal = EventModal;
;
//# sourceMappingURL=EventModal.js.map